import React from "react";
import FlightTimeDivider from "./FlightTimeDivider";
import UserAvatar from "../../../components/UserAvatar";
import FlightDateTimeContainer from "./FlightDateTimeContainer";
import TotalActionWrapper from "./TotalActionWrapper";
import styled from "styled-components";

const FlightDataBodyWrapper = ({
  detailNo,
  openDetails,
  setOpenDetails,
  flightName,
  onSelectFlight,
  imgSrc,
  isConfirmBookingPage,
}) => {
  return (
    <FlightDataBody>
      <FlightData>
        <FlightLegContainer>
          <FlightIdentityWrapper>
            <UserAvatar userName={flightName} imgSrc={imgSrc} />
            <FlightName>{flightName}</FlightName>
          </FlightIdentityWrapper>
          <FlightTimeContainer>
            <FlightDateTimeContainer
              time={"10:05"}
              date="24 Feb"
              place={"DOH"}
            />
            <FlightTimeDivider type="Direct" />
            <FlightDateTimeContainer
              time={"12:05"}
              date="24 Feb"
              place={"DXB"}
            />
          </FlightTimeContainer>
          <FlightDuration>1h 00m</FlightDuration>
        </FlightLegContainer>
        <FlightLegContainer>
          <FlightIdentityWrapper>
            <UserAvatar userName={flightName} imgSrc={imgSrc} />
            <FlightName>{flightName}</FlightName>
          </FlightIdentityWrapper>
          <FlightTimeContainer>
            <FlightDateTimeContainer
              time={"08:50"}
              date="16 Mar"
              place={"DXB"}
            />
            <FlightTimeDivider type="Direct" />
            <FlightDateTimeContainer
              time={"12:05"}
              date="16 Mar"
              place={"DOH"}
            />
          </FlightTimeContainer>
          <FlightDuration>1h 15m</FlightDuration>
        </FlightLegContainer>
      </FlightData>
      <TotalActionWrapper
        amount="1368"
        unit="QAR"
        note="plus 3% Service Tax"
        detailNo={detailNo}
        setOpenDetails={setOpenDetails}
        openDetails={openDetails}
        onSelectFlight={onSelectFlight}
        isConfirmBookingPage={isConfirmBookingPage}
      />
    </FlightDataBody>
  );
};

const FlightLegContainer = styled.div`
  display: flex;
  align-items: center;
`;

const FlightIdentityWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 30%;
`;

const FlightTimeContainer = styled.div`
  width: 55%;
  display: flex;
  justify-content: center;
  // flex-direction: column;
`;

const FlightName = styled.div`
  font-size: 1rem;
  font-weight: 600;
`;

const FlightDuration = styled.div`
  font-size: 1rem;
  font-weight: 700;
  width: 15%;
  text-align: center;
`;

const FlightData = styled.div`
  padding: 1rem;
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const FlightDataBody = styled.div`
  //   padding: 1rem 0;
  display: flex;
`;

export default FlightDataBodyWrapper;
